import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { RootState } from '../../store/store';
import { userLoggedOut } from '../auth/authSlice';

const baseQuery = fetchBaseQuery({
	baseUrl: process.env.REACT_APP_API_BASE_URL,

	prepareHeaders: (headers, { getState }) => {
		let token = (getState() as RootState).auth.accessToken;

		if (token) {
			headers.set('Authorization', `Bearer ${token}`);
		}

		headers.set('Content-type', `application/json`);
		headers.set('Accept', `application/json`);

		return headers;
	},
}) as BaseQueryFn<string | FetchArgs, unknown, any, {}>;

export const apiSlice = createApi({
	reducerPath: 'api',

	baseQuery: async (args, api, extraOptions) => {
		const result = await baseQuery(args, api, extraOptions);

		if (result?.error?.status === 401) {
			api.dispatch(userLoggedOut());

			if (api.endpoint !== 'login') {
				localStorage.clear();
				window.location.href = '/login';
			}
		} else if (result?.error?.status === 429) {
			console.log(result?.error);
		}

		return result;
	},

	tagTypes: [
		'makes',
		'models',
		'sellers',
		'vehicles',
		'showvehicle',
		'searchmodels',
		'users',
		'roles',
		'zones',
		'countries',
		'states',
		'locations',
		'auction-yards',
		'faqs',
		'members',
		'auctions',
		'dashboards',
		'c_quries',
		'product-service',
		'invoices',
		'bills',
		'downloads',
		'contents',
		'blogs',
		'latest-auction-sold',
		'latest-direct-sold',
		'paddles',
		'activity_logs',
		'alert-members',
		'activity_manual_logs',
		'reports',
		'petty-cash',
	],
	endpoints: () => ({}),
});

const baseQueryMultipart = fetchBaseQuery({
	baseUrl: process.env.REACT_APP_API_BASE_URL,

	prepareHeaders: (headers, { getState }) => {
		let token = (getState() as RootState).auth.accessToken;

		if (token) {
			headers.set('Authorization', `Bearer ${token}`);
		}

		headers.set('Content-type', 'multipart/form-data');
		headers.set('Accept', 'application/json');

		return headers;
	},
}) as BaseQueryFn<string | FetchArgs, unknown, any, {}>;

export const apiSliceFile = createApi({
	reducerPath: 'apiFile',

	baseQuery: async (args, api, extraOptions) => {
		const result = await baseQueryMultipart(args, api, extraOptions);

		if (result?.error?.status === 401) {
			api.dispatch(userLoggedOut());
			localStorage.clear();
			window.location.href = '/login';
		}

		return result;
	},
	endpoints: () => ({}),
});
